import { Record } from 'immutable';

export default Record({
    active: null,
    allowExclusiveCampaigns: false,
    boosts: null,
    campaigns: null,
    chat: false,
    followups: false,
    keywordDepth: null,
    keywords: null,
    name: null,
    planId: null,
    price: null,
    purchasable: null,
    videos: null,
});



// WEBPACK FOOTER //
// ./src/records/plan.js